module.exports = __webpack_public_path__ + "static/media/smstocontrol.fbad6ac5.png";